import {InjectionToken} from '@angular/core';

// todo(ccliu): éå¤çTokenå®ä¹æä¹åï¼

export const ALTERNATIVES = new InjectionToken('ä¸»é¡µå¯éç½®é¡¹');

export const PANEL_ID = new InjectionToken('ç»ä»¶å®ä¹id');
export const PANEL_ITEM = new InjectionToken('èµ°é©¬ç¯PanelItem');

export const TURNOVER_POSITIVE = new InjectionToken('TurnOveræ­£é¢');
export const TURNOVER_NEGATIVE = new InjectionToken('TurnOveråé¢');
